import { createContext } from 'react';

import { type MinimalUser } from '@/generated/model';

export type UserContext = {
  user: MinimalUser;
  isToken: () => boolean;
  hasExtraFeature: (extraFeature: string) => boolean;
  logout: () => void;
};

export const ctxUser = createContext<UserContext | undefined>(undefined);

export function createUserContextValue(user: MinimalUser, logout: () => void): UserContext {
  return {
    user,
    isToken: () => user.isTokenUser,
    hasExtraFeature: (extraFeature: string) => user.extraFeatures?.includes(extraFeature) ?? false,
    logout,
  };
}
